// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2021-03-02 23:12:31 +0100 (Tue, 02 Mar 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 117435 $
//  Purpose   : uix qa parts
// =============================================================================

export const parts = true
export const templates = true
export const jobs = true

import * as views from './views'
export {views}
